var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2630,
    height: 1767,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-885 -363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2971.34 1255.22C3172.9 1742.48 2762.58 2049.92 2268.12 2049.92 1773.66 2049.92 1372.79 1694.14 1372.79 1255.22 1372.79 816.295 1771.56 423.918 2265.99 423.918 2760.42 423.918 2939.69 629.222 2971.34 1255.22",
    fill: "#EBF2FC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2015.56 1965.5 2344.17 1965.5C2400.1 1965.5 2445.5 2011.17 2445.5 2067.44L2445.5 2092.5 1912.5 2092.5 1912.5 2069.19C1912.5 2011.96 1958.68 1965.5 2015.56 1965.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1982.5 1968.5C1982.5 1968.5 2001.42 1929.69 2025.25 1932.17 2035.94 1639.87 2044.17 1619.22 2038.67 1563.06 2033.2 1506.91 2033.87 1408.65 2043.34 1378.52 2044.58 1364.08 1991.95 1359.95 2016.21 1300.48 2040.47 1241.03 2070.47 1151.03 2093.5 1044.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2003.56 914.5C2003.56 914.5 1915.76 1038.57 1996.94 1048.5 2017.65 1048.5 2064.87 1026.99 2095.5 956.691",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2037.25 1520.5C2037.25 1520.5 2123.15 1277.42 2249.5 1068.21 2249.5 1068.21 2177.11 1089.98 2043.86 1212.09L2010 1155.85 2014.13 1102.1C2014.13 1102.1 1995.96 1068.21 1997.61 1052.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400.95 1163.83 2311.1 1321.59C2305.8 1330.88 2308.85 1342.68 2318 1348.25L2365.14 1377.09C2376.1 1383.78 2390.45 1380.32 2397.08 1369.34L2431.2 1313.03C2434.78 1307.12 2442.69 1305.55 2448.28 1309.64L2448.28 1309.64C2451.12 1311.72 2455.16 1310.94 2457 1307.93L2480.67 1269.38C2484.93 1262.47 2485.63 1253.93 2482.56 1246.43L2480.01 1240.18C2477.92 1235.04 2478.3 1229.24 2481.07 1224.44L2485.67 1216.42C2491.62 1206.02 2487.88 1192.79 2477.33 1187.04L2423.22 1157.52C2415.31 1153.21 2405.42 1156.02 2400.98 1163.83Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2249.5 1068.9C2249.5 1068.9 2343.68 1050.51 2341.46 1263.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2354.5 1373.5 2388.32 1615.63C2389.3 1622.71 2386.31 1629.73 2380.55 1633.86L2374.06 1638.52C2368.69 1642.37 2365.7 1648.77 2366.17 1655.41L2376.16 1799.99C2376.58 1806.21 2373.15 1812.04 2367.53 1814.63L2363.18 1816.64C2357.11 1819.43 2353.63 1825.96 2354.7 1832.61L2375.8 1965.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2023.5 1931.96C2023.5 1931.96 2045.48 1947.38 2085.06 1880.71 2111.45 1841.04 2106.5 1840.49 2144.42 1816.79 2182.33 1793.08 2220.8 1772.15 2220.8 1772.15 2220.8 1772.15 2241.68 1753.97 2212.57 1730.83 2207.62 1727.52 2193.33 1712.09 2225.75 1695.01 2230.32 1692.87 2248.12 1683.6 2268.77 1672.75 2304.39 1654.03 2348.58 1630.55 2348.58 1630.55 2348.58 1630.55 2363.43 1614.85 2372.5 1638.81",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2269.74 1676.5C2269.74 1676.5 2252.42 1870.78 2275.5 1967.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194.5 1789.5C2194.5 1789.5 2178.8 1917.09 2166.5 1962.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2244.5 1068.5 2241.5 994.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2173.84 993.017C2173.84 993.017 2249.75 1034.31 2252.5 944.556 2255.25 887.845 2262.41 838.843 2212.35 830.03 2171.1 825.635 2108.38 824.53 2114.98 917.035 2116.62 948.411 2117.19 961.642 2117.19 961.642",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2118.5 892.729C2118.5 892.729 2194.4 818.4 2250.5 895.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082.56 922.027C2082.56 922.027 2062.21 891.759 2061.67 863.158 2061.13 834.556 2060.56 802.644 2031.97 706.931 2041.87 670.628 2040.77 647.521 2023.16 611.218 2019.85 587.008 2018.77 570.5 2018.77 570.5L1967.74 570.5 1967.74 686.572C1967.74 686.572 1964.43 712.156 1982.18 714.633 1982.18 714.633 1978.87 821.9 2003.64 866.468 2006.95 897.817 2001.99 949.818 2023.43 984.477 2055.61 957.249 2082.83 925.067 2082.83 925.067 2082.83 925.067 2112.53 951.484 2137.28 996.03 2157.91 1030.69 2160.38 1071.11 2249.49 1068.64 2256.08 1130.52 2228.03 1236.98 2235.46 1362.4 2238.77 1421.81 2232.15 1477.93 2179.34 1538.17 2150.48 1567.88 2120.75 1594.29 2110.03 1619.05 2098.48 1634.72 2048.99 1672.69 2038.25 1673.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944.01 508.5 2041.71 508.5C2048.22 508.5 2053.5 513.808 2053.5 520.354L2053.5 546.67C2053.5 559.266 2043.32 569.5 2030.79 569.5L1956.43 569.5C1942.14 569.5 1930.5 557.826 1930.5 543.431L1930.5 522.063C1930.5 514.573 1936.54 508.5 1943.99 508.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.41 506.5C1974.41 506.5 1945.67 469.897 1970.81 438.5 1995.95 407.126 2007.01 408.207 2007.55 389.5 2009.77 419.499 2003.14 419.793 2015.29 439.604 2027.44 459.416 2032.69 469.604 2020.81 505.666 2000.09 505.666 1973.71 505.801 1974.38 506.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2116.5 870.5 2064.5 856.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2139.5 838.5 2083.5 781.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180.5 827.5 2180.5 729.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2221.5 832.5 2268.5 767.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2249.5 863.5 2327.5 834.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2251.5 895.5 2321.5 917.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2436.95 1305.5 2416.57 1279.66C2410.45 1271.89 2411.33 1260.73 2418.55 1254L2444.96 1229.42C2451.3 1223.52 2460.9 1222.85 2468.01 1227.82L2473.5 1231.67",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.bb538d55d7cf7c2e72e180b856d52414.svg";
export { ForwardRef as ReactComponent };